var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRevertUpcomingConfirmIcon = function SvgRevertUpcomingConfirmIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A5ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3776AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.3.2.10.2-All-screenings-/-View-action-/-Revert-to-upcoming",
    transform: "translate(-672.597015, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext",
    transform: "translate(520.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597015, 40.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "repeat-1",
    mask: "url(#mask-3)",
    fill: "#FFEFF0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 8.333333)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7994712,0.337932692 C19.2501202,-0.112644231 19.980649,-0.112644231 20.4312981,0.337932692 L23.8928365,3.79947115 C24.3434135,4.25012019 24.3434135,4.98064904 23.8928365,5.43129808 L20.4312981,8.89283654 C19.980649,9.34341346 19.2501202,9.34341346 18.7994712,8.89283654 C18.3488942,8.4421875 18.3488942,7.71165865 18.7994712,7.26100962 L20.2913221,5.76923077 L6.92487981,5.76923077 C5.70158654,5.77334135 4.52956731,6.26105769 3.66455048,7.12608173 C2.79952644,7.99110577 2.31177404,9.163125 2.30769231,10.3864183 L2.30769231,11.5384615 C2.30769231,12.1757452 1.79110096,12.6923077 1.15384615,12.6923077 C0.516591346,12.6923077 0,12.1757452 0,11.5384615 L0,10.3846154 L0,10.3811538 C0.00548076923,8.54762019 0.736269231,6.79081731 2.03276683,5.49432692 C3.32926442,4.19783654 5.08608173,3.46701923 6.91961538,3.46153846 L6.92307692,3.46153846 L20.2913221,3.46153846 L18.7994712,1.96975962 C18.3488942,1.51911058 18.3488942,0.788581731 18.7994712,0.337932692 Z M28.8461538,9.23076923 C29.4834375,9.23076923 30,9.74733173 30,10.3846154 L30,11.5384615 L30,11.5419231 C29.9945192,13.3754567 29.2637019,15.1322596 27.9672115,16.42875 C26.6707212,17.7252404 24.9139183,18.4560577 23.0803846,18.4615385 L23.0769231,18.4615385 L9.70867788,18.4615385 L11.2005288,19.9533173 C11.6511058,20.4039663 11.6511058,21.1344952 11.2005288,21.5851442 C10.7498798,22.0357212 10.019351,22.0357212 9.56870192,21.5851442 L6.10716346,18.1236058 C5.65658654,17.6729567 5.65658654,16.9424279 6.10716346,16.4917788 L9.56870192,13.0302404 C10.019351,12.5796635 10.7498798,12.5796635 11.2005288,13.0302404 C11.6511058,13.4808894 11.6511058,14.2114183 11.2005288,14.6620673 L9.70867788,16.1538462 L23.0751923,16.1538462 C24.2984856,16.1497356 25.4704327,15.6620192 26.3354567,14.7969952 C27.2005529,13.931899 27.6882692,12.7598077 27.6923077,11.5364423 L27.6923077,10.3846154 C27.6923077,9.74733173 28.2088702,9.23076923 28.8461538,9.23076923 Z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRevertUpcomingConfirmIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/revert-upcoming-confirm-icon.082ee7d6.svg";
export { ForwardRef as ReactComponent };